module.exports = __webpack_public_path__ + "img/234.d302b0b1.png";